import { render, staticRenderFns } from "./mainWeb.vue?vue&type=template&id=443382de"
import script from "./mainWeb.vue?vue&type=script&lang=js"
export * from "./mainWeb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports